module.exports = require("query-string");